import { CalendarPlanActivityClientData } from '@yandex-int/k-common/typings';
import { CONTENT_TYPE } from '@yandex-int/k-common/typings/api/models/content';
import { SUBJECTS_SLUGS_TYPE } from 'platform-components';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { getDefaultCourseId } from 'store/courses/selectors';
import { prepLessonsActions } from 'store/prep-lessons/actions';
import { getPrepLessonsDetailsLoadingStatus } from 'store/prep-lessons/selectors';

export const useLessonAssignment = (subject: SUBJECTS_SLUGS_TYPE, items: CalendarPlanActivityClientData[]) => {
    const dispatch = useDispatch();
    const { classId } = useParams<Record<string, string>>();
    const teamId = Number(classId);
    const courseId = useSelector((store) => getDefaultCourseId(store, { subject, classId: teamId }));
    const lessonsIds = items
        .filter((item) => item.content_type === CONTENT_TYPE.LESSON)
        .map((item) => Number(item.content_id));
    const prepLessonDetailsLoadingStatus = useSelector((store) =>
        getPrepLessonsDetailsLoadingStatus(store, { courseId, lessonsIds: lessonsIds })
    );

    useEffect(() => {
        if (courseId && lessonsIds.length > 0) {
            dispatch(
                prepLessonsActions.loadPrepLessonsDetailsRequest({
                    courseId,
                    lessonsIds,
                })
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [courseId]);

    return prepLessonDetailsLoadingStatus;
};
